import { bind } from 'decko';
import { inject } from 'mobx-react';
import React from 'react';

import Env from '../../../../lib/src/Env';
import Validate, { Validation } from '../../../../lib/src/helpers/Validate';
import { InjectedInvitationDraftProps } from '../../../../lib/src/managers/InvitationDraftManager';
import { InjectedAccountProps } from '../../Account';
import Alert from '../../helpers/Alert';
import DatePicker from '../forms/DatePicker';

interface Props {
    onConfirm?: () => void;
    onCancel?: () => void;
}

@inject('account', 'invitationDraft')
export default class InviteDatePicker extends React.Component<Props> {
    private datePickerRef = React.createRef<DatePicker>();

    private get injected() {
        return this.props as Props & InjectedAccountProps & InjectedInvitationDraftProps;
    }

    public open() {
        this.datePickerRef.current?.open();
    }

    public render() {
        return (
            <DatePicker
                ref={this.datePickerRef}
                onChange={this.handleConfirm}
                onCancel={this.handleCancel}
                validate={this.validate}
            />
        );
    }

    @bind
    private validate(date: Date) {
        const { restaurant } = this.injected.invitationDraft;

        return restaurant
            ? Validate.restaurantDate(restaurant, date)
            : Validation.success;
    }

    @bind
    private handleConfirm(date: Date) {
        const { invitationDraft } = this.injected;

        Env.logEvent('confirm_meetup_date');

        invitationDraft.date = date;

        Alert.confirmInvitationTakeAway(isTakeAway => {
            invitationDraft.isTakeAway = isTakeAway;

            if (this.props.onConfirm) {
                this.props.onConfirm();
            }
        });
    }

    @bind
    private handleCancel() {
        Env.logEvent('cancel_meetup_date');

        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }
}
